import blog1 from "../data/blogs/blog1";
import blog2 from "../data/blogs/blog2";
import blog3 from "../data/blogs/blog3";
import blog4 from "../data/blogs/blog4";
import blog5 from "../data/blogs/blog5";
import blog6 from "../data/blogs/blog6";
import blog7 from "./blogs/blog7";
import blog8 from "./blogs/blog8";
import blog9 from "./blogs/blog9";
import blog10 from "./blogs/blog10";
import blog11 from "./blogs/blog11";
import blog12 from "./blogs/blog12";
import blog13 from "./blogs/blog13";
import blog14 from "./blogs/blog14";
import blog15 from "./blogs/blog15";
import blog16 from "./blogs/blog16";
import blog17 from "./blogs/blog17"; 
import blog18 from "./blogs/blog18";
import blog19 from "./blogs/blog19";
import blog20 from "./blogs/blog20";
import blog21 from "./blogs/blog21";
import blog22 from "./blogs/blog22";
import blog23 from "./blogs/blog23";
import blog24 from "./blogs/blog24";
import blog25 from "./blogs/blog25";
import blog26 from "./blogs/blog26";
import blog27 from "./blogs/blog27";
import blog28 from "./blogs/blog28";
import blog29 from "./blogs/blog29";
import blog30 from "./blogs/blog30";
import blog31 from "./blogs/blog31";
import blog32 from "./blogs/blog32";
import blog33 from "./blogs/blog33";
import blog34 from "./blogs/blog34";
import blog35 from "./blogs/blog35";
import blog36 from "./blogs/blog36";
import blog37 from "./blogs/blog37";
import blog38 from "./blogs/blog38";
import blog39 from "./blogs/blog39";
import blog40 from "./blogs/blog40";
import blog41 from "./blogs/blog41";
import blog42 from "./blogs/blog42";
import blog43 from "./blogs/blog43";
import blog44 from "./blogs/blog44";
import blog45 from "./blogs/blog45";
import blog46 from "./blogs/blog46";
import blog47 from "./blogs/blog47";
import blog48 from "./blogs/blog48";
import blog49 from "./blogs/blog49";
import blog50 from "./blogs/blog50";
import blog51 from "./blogs/blog51";
import blog52 from "./blogs/blog52";
import blog53 from "./blogs/blog53";

export const blogs = [
  blog1,
  blog2,
  blog3,
  blog4,
  blog5,
  blog6,
  blog7,
  blog8,
  blog9,
  blog10,
  blog11,
  blog12,
  blog13,
  blog14,
  blog15,
  blog16,
  blog17,
  blog18,
  blog19,
  blog20,
  blog21,
  blog22,
  blog23,
  blog24,
  blog25,
  blog26,
  blog27,
  blog28,
  blog29,
  blog30,
  blog31,
  blog32,
  blog33,
  blog34,
  blog35,
  blog36,
  blog37,
  blog38,
  blog39,
  blog40,
  blog41,
  blog42,
  blog43,
  blog44,
  blog45,
  blog46,
  blog47,
  blog48,
  blog49,
  blog50,
  blog51,
  blog52,
  blog53,
];